import React from 'react';
import { TableCell, TableRow } from 'carbon-components-react';
import { ChevronRight16, StarFilled16, ViewOff16 } from '@carbon/icons-react';
import Utils from 'utilities/helper.util';
import { SCREEN_SIZE } from 'types';

type OwnProps = {
  row: any;
  getRowProps: any;
  handleCLOViewDetailsClick: Function;
  screenSize: string;
};

type Props = OwnProps;

const CLOModalListingRow: React.FC<Props | any> = (props: Props) => {
  const { row, getRowProps, handleCLOViewDetailsClick, screenSize } = props;

  return (
    <TableRow
      {...getRowProps({ row })}
      onClick={() => handleCLOViewDetailsClick(row.cells[0].value, 'listing')}
      className="row-style"
    >
      <TableCell key={`info`}>
        <div className="clo-info">
          <div className="clo-name">{row.cells[1].value}</div>
          <div className="clo-desc">
            <div>
              {`${row.cells[2].value} Certified Locator${
                row.cells[2].value > 1 ? 's' : ''
              }`}
              {screenSize !== SCREEN_SIZE.SM ? '.' : ''}
            </div>
            <div>
              {row.cells[3].value &&
                Utils.getFullAddress(row.cells[3].value, true)}
            </div>
          </div>
        </div>
      </TableCell>
      <TableCell className="column-menu">
        <div className="preferences-indicator-container">
          {row.cells[5].value && (
            <div>
              <ViewOff16 />
            </div>
          )}
          {row.cells[4].value && (
            <div>
              <StarFilled16 className="star-colour" />
            </div>
          )}
          {screenSize === SCREEN_SIZE.SM && (
            <div>
              <ChevronRight16 />
            </div>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default CLOModalListingRow;
